import 'bootstrap/dist/css/bootstrap.min.css';
import ITCLogo from '../../assets/Images/CommonImages/ITClogo.png';
import DriverAlerts from '../Dispatch/Alerts/DriverAlerts.js';
import APICom from "../../utils/helpers/APICom.js";
import React, { useState, useEffect, useRef } from 'react';
import {Button, Modal} from 'react-bootstrap';
import { Icon } from '@iconify/react/dist/iconify.js';
import PermPhoneMsgIcon from '@mui/icons-material/PermPhoneMsg';
import EditNotificationsIcon from '@mui/icons-material/EditNotifications';
import PersistStorage from '../../utils/helpers/PersistStorage.js';
import Messaging from '../Controls/Messaging.js';

import MDT_notification from '../../assets/Audio/MDT_notification.wav'

const HeaderComponent = ({affSelected, loginData}) => {
    // const { loginData } = useSelector((store) => store.login);
    const [showDriverAlerts, setShowDriverAlerts] = useState(false);
    const [showAlertsTitleHTML, setShowAlertsTitleHTML] = useState(null);
    const [winWidth, setWinWidth] = useState(window.innerWidth);
    const [AffChange, setAffChange] = useState(0);
    const [showMessaging, setShowMessaging] = useState(false);
    const [showRouteMessaging, setShowRouteMessaging] = useState(false);
    const [notifIcon, setNotifIcon] = useState(localStorage.getItem('notifIcon') === 'true' ? true : false);
    const [showCustomerManagement, setShowCustomerManagement] = useState(false);
    const [showNotifications, setshowNotifications] = useState(false);
    const AffiliateIDForAlertsRef = useRef(null);
    const AlertsRef = useRef(null);
    const xCancelSourceForGrid = useRef(null);
    const UserLoginData = useRef([]);
    const prevVeh = useRef();
    const lastMessID = useRef(-1);
    const [isFetching, setIsFetching] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const handleShowAlertCounts = async(aff)=>{
        try{
            let data = {
                "selectedAffiliate": (aff?
                    aff:(UserLoginData.current? parseInt(UserLoginData.current.UserAffiliateList?.split(",")[0]):parseInt(loginData.UserAffiliateList?.split(",")[0])))
            };
            xCancelSourceForGrid.current = APICom.GenerateSource();
            let response = await APICom.fetchData("main","TripActions/GetAlarmsSummary", "post", {}, data, xCancelSourceForGrid.current, false);
            if(response.data && response.data.AllAlerts.length > 0)
            {
                // let countDataArr = response.data.AllAlerts[0];
                let driverPenaltyCountForAff = 0;
                let emergencyCount = 0;
                let noshowCount = 0;
                let othersCount = 0;
                let lateCount = 0;
                let deviceCount = 0;
                let alarmsArr = response.data.Alarms;
                let alertsArr = response.data.AlertDetails;
                let driverPenaltyArr = (Array.isArray(response.data.DriverPenalty) && response.data.DriverPenalty.length > 0 ? response.data.DriverPenalty[0] : null);
                let deviceLockArr = (Array.isArray(response.data.DeviceDetails) && response.data.DeviceDetails.length > 0 ? response.data.DeviceDetails[0] : null);
                let LateTripsArr = (Array.isArray(response.data.LateDetails) && response.data.LateDetails.length > 0 ? response.data.LateDetails[0] : null);
                
                driverPenaltyCountForAff = (driverPenaltyArr && driverPenaltyArr.DriverPenaltyCount? parseInt(driverPenaltyArr.DriverPenaltyCount) : 0);
                deviceCount = (deviceLockArr && deviceLockArr.DeviceDetailsCount? parseInt(deviceLockArr.DeviceDetailsCount) : 0);
                lateCount = (LateTripsArr && LateTripsArr.LateAlertCount? parseInt(LateTripsArr.LateAlertCount) : 0);
                
                if(alarmsArr && alarmsArr.length > 0)
                {
                    othersCount += alarmsArr[0].Other;
                    emergencyCount += alarmsArr[0].EMERGENCY;
                    noshowCount += alarmsArr[0].NOSHOWREQ;
                }
                else if(alertsArr && alertsArr.length > 0)
                {
                    othersCount += alertsArr[0].AlertCount;
                }

                let alertsTitleHTML = function(index){
                    return(
                            <span key={index} style={{fontSize:"small"}}> 
                            {/* <span className='text-center my-auto mx-1 p-1 bg-white circle' 
                                style={{cursor:"pointer", width:"35px", height:"35px"}} title={"Customer Management"} onClick={()=>{setShowCustomerManagement(true);}}
                            >
                                <Icon className='text-dark my-auto' style={{width:"20px", minWidth:"20px", height:"20px"}} icon={'ix:customer'}/> 
                            </span> */}

                            {notifIcon ?
                    
                            (<span className='text-center my-auto mx-1 p-1 circle' 
                                style={{cursor:"pointer", width:"35px", height:"35px", backgroundColor:"#f7a51a"}} title={"Driver MDT Messaging"} onClick={()=>{setShowMessaging(true); }}
                            >
                                <Icon className='text-dark my-auto' style={{width:"20px", minWidth:"20px", height:"20px"}} icon={'bx:chat'}/> 
                            </span>)
                    
                            : (<span className='text-center my-auto bg-white mx-1 p-1 circle' 
                                style={{cursor:"pointer", width:"35px", height:"35px"}} title={"Driver MDT Messaging"} onClick={()=>{setShowMessaging(true); }}
                            >
                                <Icon className='text-dark my-auto' style={{width:"20px", minWidth:"20px", height:"20px"}} icon={'bx:chat'}/> 
                            </span>)}
                            {/**Not needed for CAT for now. */}
                            {/* <span className='text-center my-auto mx-1 p-1 bg-white circle' 
                                style={{cursor:"pointer", width:"35px", height:"35px"}} title={"Driver Route Messaging"} onClick={()=>{setShowRouteMessaging(true);}}
                            >
                                <PermPhoneMsgIcon className='text-dark my-auto' style={{width:"20px", minWidth:"20px", height:"20px"}}/>

                            </span> */}
                            {/**Not needed for CAT for now. */}
                            <span className='text-center my-auto mx-1 p-1 bg-white circle' 
                                style={{cursor:"pointer", width:"35px", height:"35px"}} title={"Robo Notifications"} onClick={()=>{setshowNotifications(true);}}
                            >
                                <EditNotificationsIcon className='text-dark my-auto' style={{width:"20px", minWidth:"20px", height:"20px"}}/>

                            </span>
                            
                            <span className='text-dark bg-white small px-2 py-1' onClick={handleOpenAlerts} style={{cursor:'pointer', borderRadius:"10px"}}>{"ALERTS"}</span>
                            <span className='text-white mx-1 px-1 fw-normal'>
                                <span title={"Emergency Alert Count"} style={{fontSize:"small"}}>
                                    {"| EM"} 
                                    {emergencyCount > 0 ? 
                                        <span className='fw-bold text-danger mx-1'>{emergencyCount}</span>
                                        :<span className='fw-bold text-white mx-1'>{0}</span>
                                    }
                                </span>
                                <span title={"No-Show Alert Count"} style={{fontSize:"small"}}>
                                    {"| NS"} 
                                    {noshowCount > 0 ? 
                                        <span className='fw-bold text-danger mx-1'>{noshowCount}</span>
                                        :<span className='fw-bold text-white mx-1'>{0}</span>
                                    }
                                </span>
                                <span title={"Late Pickup Alert Count"} style={{fontSize:"small"}}>
                                    {"| LT"} 
                                    {lateCount > 0 ? 
                                        <span className='fw-bold text-danger mx-1'>{lateCount}</span>
                                        :<span className='fw-bold text-white mx-1'>{0}</span>
                                    }
                                </span>
                                <span title={"Device Lock Alert Count"} style={{fontSize:"small"}}>
                                    {"| DL"} 
                                    {deviceCount > 0 ? 
                                        <span className='fw-bold text-danger mx-1'>{deviceCount}</span>
                                        :<span className='fw-bold text-white mx-1'>{0}</span>
                                    }
                                </span>
                                <span title={"Driver Penalty Count"} style={{fontSize:"small"}}>
                                    {"| DP"} 
                                    {driverPenaltyCountForAff > 0 ? 
                                        <span className='fw-bold text-danger mx-1'>{driverPenaltyCountForAff}</span>
                                        :<span className='fw-bold text-white mx-1'>{0}</span>
                                    }
                                </span>
                                <span title={"Other Alerts Count"} style={{fontSize:"small"}}>
                                    {"| OT"} 
                                    {othersCount > 0 ? 
                                        <span className='fw-bold text-danger mx-1'>{othersCount}</span>
                                        :<span className='fw-bold text-white mx-1'>{0}</span>
                                    }
                                </span>
                            </span>
                        </span>
                    );
                };

                setShowAlertsTitleHTML(alertsTitleHTML);
            }
        }
        catch(err){console.log(err);}
    };

    const DefaultEmptyAlerts = () => {
        let alertsTitleHTML = function (index) {
            return (
                
                <span key={index} style={{fontSize: "small"}}> 
                     {/* <span className='text-center my-auto mx-1 p-1 bg-white circle' 
                                style={{cursor:"pointer", width:"35px", height:"35px"}} title={"Customer Management"} onClick={()=>{setShowCustomerManagement(true);}}
                            >
                                <Icon className='text-dark my-auto' style={{width:"20px", minWidth:"20px", height:"20px"}} icon={'ix:customer'}/> 
                    </span> */}
                    {notifIcon ?
                    
                    (<span className='text-center my-auto mx-1 p-1 circle' 
                        style={{cursor:"pointer", width:"35px", height:"35px", backgroundColor:"#f7a51a"}} title={"Driver MDT Messaging"} onClick={()=>{setShowMessaging(true); }}
                    >
                        <Icon className='text-dark my-auto' style={{width:"20px", minWidth:"20px", height:"20px"}} icon={'bx:chat'}/> 
                    </span>)
            
                    : (<span className='text-center my-auto bg-white mx-1 p-1 circle' 
                        style={{cursor:"pointer", width:"35px", height:"35px"}} title={"Driver MDT Messaging"} onClick={()=>{setShowMessaging(true); }}
                    >
                        <Icon className='text-dark my-auto' style={{width:"20px", minWidth:"20px", height:"20px"}} icon={'bx:chat'}/> 
                    </span>)}

                    {/**Not needed for CAT for now. */}
                    {/* <span className='text-center my-auto mx-1 p-1 bg-white circle' 
                                style={{cursor:"pointer", width:"35px", height:"35px"}} title={"Driver Route Messaging"} onClick={()=>{setShowRouteMessaging(true);}}
                            >
                                <PermPhoneMsgIcon className='text-dark my-auto' style={{width:"20px", minWidth:"20px", height:"20px"}}/>

                    </span> */}
                    {/**Not needed for CAT for now. */}
                    <span className='text-center my-auto mx-1 p-1 bg-white circle' 
                                style={{cursor:"pointer", width:"35px", height:"35px"}} title={"Robo Notification logs"} onClick={()=>{setshowNotifications(true);}}
                            >
                                <EditNotificationsIcon className='text-dark my-auto' style={{width:"20px", minWidth:"20px", height:"20px"}}/>

                            </span>
                            
                    
                    <span className='text-dark bg-white small px-2 py-1' onClick={handleOpenAlerts} style={{cursor:'pointer', borderRadius: "10px"}}>{"ALERTS"}</span>
                    <span className='text-white mx-1 px-1 fw-normal'>
                        <span title={"Emergency Alert Count"} style={{fontSize: "small"}}>
                            {"| EM"} <span className='fw-bold text-white mx-1'>{0}</span>
                        </span>
                        <span title={"No-Show Alert Count"} style={{fontSize: "small"}}>
                            {"| NS"}
                            <span className='fw-bold text-white mx-1'>{0}</span>
                        </span>
                        <span title={"Late Pickup Alert Count"} style={{fontSize: "small"}}>
                            {"| LT"}
                            <span className='fw-bold text-white mx-1'>{0}</span>
                        </span>
                        <span title={"Device Lock Alert Count"} style={{fontSize: "small"}}>
                            {"| DL"}
                            <span className='fw-bold text-white mx-1'>{0}</span>
                        </span>
                        <span title={"Driver Penalty Count"} style={{fontSize: "small"}}>
                            {"| DP"}
                            <span className='fw-bold text-white mx-1'>{0}</span>
                        </span>
                        <span title={"Other Alerts Count"} style={{fontSize: "small"}}>
                            {"| OT"}
                            <span className='fw-bold text-white mx-1'>{0}</span>
                        </span>
                    </span>
                </span>
            );
        };
        setShowAlertsTitleHTML(alertsTitleHTML);
    };

    const handleOpenAlerts = ()=>{
        
        if(Object.keys(UserLoginData.current)?.length > 0)
        {
            setShowDriverAlerts(true);
            if(AffiliateIDForAlertsRef.current && AffiliateIDForAlertsRef.current !== ''){
                handleShowAlertCounts(AffiliateIDForAlertsRef.current);
            }
        }
        else
        {
            setShowDriverAlerts(false);
        }
    };

    const checkNotifIcon = () => {
        if(localStorage.getItem("notifIcon") === "false"){
            setNotifIcon(false);
        }
        if(localStorage.getItem("notifIcon") === "true"){
            setNotifIcon(true);
        }
        setTimeout(() => {
            checkNotifIcon();
        }, 1000)
    }

    useEffect(() => {
        if(affSelected) {
            AffiliateIDForAlertsRef.current = parseInt(affSelected);
        }
    }, [affSelected]);

    useEffect(() => {
        try{
            const isCallAgent = window.location.href.toLowerCase().includes("callagent");
            const isMessaging = window.location.href.toLowerCase().includes("messaging");
            const isLoginEmpty = Object.keys(loginData)?.length === 0;
            if(isLoginEmpty || isCallAgent || isMessaging)
            {
                setShowAlertsTitleHTML(<span>{"ALERTS"}</span>);
                if(AlertsRef.current){
                    AlertsRef.current.className = "d-none";
                }
            }
            else
            {
                UserLoginData.current = loginData;

                if(AffiliateIDForAlertsRef.current && AffiliateIDForAlertsRef.current !== "" && AffiliateIDForAlertsRef.current !== 0)
                {
                    handleShowAlertCounts(AffiliateIDForAlertsRef.current);
                }
                else {
                    DefaultEmptyAlerts();
                }
                
                if(AlertsRef.current){
                    AlertsRef.current.className = "m-0 mx-2 text-white fw-bold bg-dark float-end px-2 py-1 shadow user-select-none d-block";
                }
            }
        }
        catch(err){console.log(err);}
        const interval = setInterval(() => {
          if (Object.keys(UserLoginData.current)?.length > 0) {
            handleShowAlertCounts(AffiliateIDForAlertsRef.current);
          }
        }, 30000);
      
        // Clear interval on component unmount
        return () => clearInterval(interval);
    }, [loginData, notifIcon]);

    useEffect(()=>{
        try{
            let resizeTimeout = 0;
            const handleResize = () =>{
                try{
                  clearTimeout(resizeTimeout); //clear if resizing continues
                  resizeTimeout = setTimeout(() => {
                    setWinWidth(window.innerWidth);
                  }, 100);
                }
                catch(err){console.log(err);}
            };

            if(document.readyState === 'complete') {
                let familySelectionMemory = PersistStorage.retrieve("_SelectedFamilyAffiliates", false);

                if(!AffiliateIDForAlertsRef.current && familySelectionMemory){
                    AffiliateIDForAlertsRef.current = parseInt(familySelectionMemory);
                    handleShowAlertCounts(AffiliateIDForAlertsRef.current);
                }

            }
              
            window.addEventListener('resize', handleResize);

            return()=>{window.removeEventListener('resize', handleResize);}
        }
        catch(err){console.log(err);}
    }, []);

    useEffect(()=>{
        try{
            if(showMessaging){
                PersistStorage.save('passedAff', parseInt(affSelected), 9999, true);
                window.open(`/Messaging`, 'com_domain_messagingScreen');
                setShowMessaging(false);
            }
        } catch(err){}
    }, [showMessaging]);

    useEffect(()=>{
        try{
            if(showRouteMessaging){
                PersistStorage.save('passedAff', parseInt(affSelected), 9999, true);
                window.open(`/DriverRouteMessaging`, 'com_domain_routeMessagingScreen');
                setShowRouteMessaging(false);
            }
        } catch(err){}
    }, [showRouteMessaging]);

    useEffect(()=>{
        try{
            if(showNotifications){
                PersistStorage.save('passedAff', parseInt(affSelected), 9999, true);
                window.open(`/Notificationlogs`, 'com_domain_routeNotificationScreen');
                setshowNotifications(false);
            }
        } catch(err){}
    }, [showNotifications]);

    useEffect(()=>{
        if (isNaN(parseInt(affSelected)) === false && affSelected !== 0) {
            const fetchData = async () => {
                try {
                  await updateDriverMsgs();
                } catch (err) {
                  console.error("Error updating driver messages:", err);
                }
              };
              fetchData();
        }
    }, [affSelected]);

    useEffect(() => {
        // Check if notification permission is granted when the component mounts
        if (Notification.permission === "default") {
            setShowModal(true); // Show modal if permission is not granted
        }
        checkNotifIcon();
    }, []);

    const requestPermission = () => {
        Notification.requestPermission().then((permission) => {
            if (permission === "granted") {
                setShowModal(false); // Close the modal if permission is granted
            } else {
                alert("Notifications not enabled.");
            }
        });
    };

    useEffect(()=>{
        try{
            if(showCustomerManagement){
                // PersistStorage.save('passedAff', parseInt(affSelected), 9999, true);
                window.open(`/CustomerManagement`, 'com_domain_CustomerManagement');
                setShowCustomerManagement(false);
            }
        } catch(err){}
    }, [showCustomerManagement]);


    async function updateDriverMsgs(){
        if (isFetching) return;
        setIsFetching(true);
        try{
            const toDateVal = 'now';
            let fromDateVal = 'today';

            let data = {
                atspid: parseInt(affSelected),
                newMessagePopupLastMessID: lastMessID.current,
                driverID: (""),
                vehicleID: String(-1),
                userID: 'LoginUser',
                dispatcherUserID: String(loginData.iUserID),
                deviceID: String(''),
                toDate: toDateVal,
                fromDate: fromDateVal,
                tillDate: (new Date()),
                lastMessID: lastMessID.current
            };


            const loadMsgResponse = await APICom.fetchData("ReservationCoreURL","api/ParatransitCT/LoadGeneralMessageNotifications", "post", {}, data, null);

            if(loadMsgResponse && loadMsgResponse.error.length === 0 ){
                if (parseInt(loadMsgResponse.data.NewMessageAlertLastMessID)!== -1){
                    lastMessID.current = parseInt(loadMsgResponse.data.NewMessageAlertLastMessID);
                }
                

                const filteredData = Object.fromEntries(
                Object.entries(loadMsgResponse.data.VehicleCounts).filter(([key]) => key !== '')
                );
                
                if (Object.keys(filteredData).length > 0){
                    const keys = Object.keys(filteredData);

                    Object.keys(filteredData).forEach((key) => {
                        const numOfMsgs = filteredData[key];

                        if (numOfMsgs > 0) {
                            setNotifIcon(true);
                            localStorage.setItem("notifIcon", true)
                            localStorage.setItem(`DriverMsg_${key}`, "newMsg");
                        }

                        if (prevVeh.current !== key && filteredData[key] > 0) {
                            const canNotify = () => Notification.permission === 'granted';
                            if (canNotify()) {
                                var notifAudio = new Audio(MDT_notification);
                                notifAudio.play().catch((err) => {
                                    console.error('Error playing notification audio:', err);
                                });
                            }
                            prevVeh.current = key;
                        }
                    });
                        
                }
            }
            setTimeout(() => {
                setIsFetching(false);
                if(localStorage.getItem("notifIcon") === "false"){
                    setNotifIcon(false);
                }
                CallLoadGeneralMessage();
            }, 15000);
        }
        catch(err){console.log(err);}
        finally{
        }
    }

    const CallLoadGeneralMessage = async() => {
        try {
            await updateDriverMsgs();
        } catch (error) {
            setTimeout(() => {
                CallLoadGeneralMessage();
            }, 30000);
        }
    }

    return (
        <>
            <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Enable Notifications</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>We would like to send you notifications for important updates. Please enable notifications for a better experience.</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Close
                    </Button>
                    <Button variant="primary" style={{ backgroundColor: "#32728b", borderColor: "#32728b" }} onClick={requestPermission}>
                        Enable Notifications
                    </Button>
                </Modal.Footer>
            </Modal>

            <nav className="navbar fixed-top my-auto navbar-expand-lg w-100 page-header d-flex justify-content-between" style={{height:'50px'}}>
                <img src={ITCLogo} className='ITCLogo page-header-logo user-select-none' alt="ITCurves" />
                {winWidth < 540 ? 
                    <span className='float-end text-end my-auto d-inline-flex' style={{cursor:"pointer"}} title={"Display Driver Alerts"} onClick={handleOpenAlerts}>
                        <Icon className='text-danger me-2 my-auto' style={{width:"20px", minWidth:"20px", height:"20px"}} icon={'oui:alert'}/> 
                    </span>
                    :
                    <p className='m-0 mx-2 text-white fw-bold bg-dark float-end px-2 py-1 HeaderAlertResponsive shadow user-select-none' 
                        ref={AlertsRef} title={"Display Driver Alerts"} style={{borderRadius:"10px"}}
                    >
                        {showAlertsTitleHTML}
                    </p>
                }
                <DriverAlerts selectedAff={AffiliateIDForAlertsRef.current} showDriverAlerts={showDriverAlerts} setShowDriverAlerts={setShowDriverAlerts}/>
                {/* {showMessaging ? <Messaging showMessaging={showMessaging} setShowMessaging={setShowMessaging} passedAff = {affSelected}/> : ''}  */}
            </nav>
        </>
    );

};

export default HeaderComponent;